import { apiBase } from "./base";

const apiVor = {
	client: apiBase.get_client(),
	url: "/smetdocs/vor/",

	getViewerData({ vorId }) {
		return this.client.get(this.url + vorId + "/", apiBase.get_headers());
	},

	delete({ vorId }) {
		return this.client.delete(this.url + vorId + "/", apiBase.get_headers());
	},

	getSourceXmlWithoutJusts({ vorId }) {
		const headers = apiBase.get_headers();
		headers["responseType"] = "blob";
		return this.client.get(this.url + "xml/input/" + vorId + "/without_justs/", headers);
	},

	getSourceXmlWithJusts({ vorId }) {
		const headers = apiBase.get_headers();
		headers["responseType"] = "blob";
		return this.client.get(this.url + "xml/input/" + vorId + "/with_justs/", headers);
	},

	createXmlWithoutJusts({ vorId }) {
		const headers = apiBase.get_headers();
		headers["responseType"] = "text/xml";
		return this.client.get(this.url + "xml/output/" + vorId + "/without_justs/", apiBase.get_headers());
	},

	createProjectXmlWithoutJusts({ projectId }) {
		const headers = apiBase.get_headers();
		headers["responseType"] = "blob";
		return this.client.get(this.url + "xml/output/project/" + projectId + "/without_justs/", headers);
	},

	createXmlWithJusts({ vorId }) {
		const headers = apiBase.get_headers();
		headers["responseType"] = "blob";
		return this.client.get(this.url + "xml/output/" + vorId + "/with_justs/", headers);
	},

	uploadJust({ file, estmId }) {
		const formData = new FormData();
		formData.append("file", file);

		return this.client.post(this.url + "upload_just/" + estmId + "/", formData, {
			headers: {
				"Content-Type": "multipart/form-data",
				Authorization: localStorage.getItem("accessToken"),
				"Auth-Uuid": localStorage.getItem("authUuid"),
			},
		});
	},

	getJustFile({ vorId, fileId }) {
		const headers = apiBase.get_headers();
		headers["responseType"] = "blob";
		return this.client.get(this.url + "just/" + vorId + "/" + fileId + "/", headers);
	},

	getJustStatus({ estmId }) {
		return this.client.get(this.url + "just_status/" + estmId + "/", apiBase.get_headers());
	},

	getPrintXlsx({ vorId }) {
		const headers = apiBase.get_headers();
		headers["responseType"] = "blob";
		return this.client.get(this.url + "print/xlsx/" + vorId + "/", headers);
	},

	getImportPrintXlsxVor({ vorId }) {
		const headers = apiBase.get_headers();
		headers["responseType"] = "blob";
		return this.client.get(this.url + "print/import/xlsx/" + vorId + "/", headers);
	},

	getProjectPrintXlsx({ projectId }) {
		const headers = apiBase.get_headers();
		headers["responseType"] = "blob";
		return this.client.get(this.url + "print/xlsx/project/" + projectId + "/", headers);
	},

	getVorExampleXslx() {
		const headers = apiBase.get_headers();
		headers["responseType"] = "blob";
		return this.client.get(this.url + "xlsx_example/", headers);
	},

	copyDoc({ estmId }) {
		return this.client.get(this.url + "copy/" + estmId + "/", apiBase.get_headers());
	},

	getConnectedLsrItems({ workId }) {
		return this.client.get(this.url + "connected_lsr_items/" + workId + "/", apiBase.get_headers());
	},
};

export default apiVor;
